import React, { ReactNode } from 'react';

interface InputFrameProps {
    label: string;
    /**
     * `id` do controle que este rótulo nomeia.
     *
     * Sem ele o `<label>` é texto solto ao lado de um campo: leitor de tela não anuncia o nome, e
     * clicar no texto não foca o controle. O rótulo aqui é FLUTUANTE (fica posicionado sobre o
     * input), então a associação não acontece por aninhamento como num formulário comum — tem de
     * ser explícita. Opcional para não quebrar as ~48 telas que já usam o frame sem passar id.
     */
    htmlFor?: string;
    errorMessage?: string;
    className?: string;
    children: ReactNode;
    prefix?: ReactNode;
    textColor?: string;
    labelClassName?: string;
}

const InputFrame: React.FC<InputFrameProps> = ({ label, htmlFor, labelClassName, errorMessage, className, children, prefix, textColor = "text-gray-500" }) => {
    let peerFocusColor = "peer-focus:text-blue-600 dark:peer-focus:text-blue-400";

    if (errorMessage) {
        peerFocusColor = "peer-focus:text-red-600 dark:peer-focus:text-red-400";
    }

    return (
        <div className={`relative z-0 ${className}`}>
            <div className="flex items-center">
                {prefix && <span className={`dark:text-slate-100 mr-2 text-sm ${textColor} ${peerFocusColor}`}>{prefix}</span>}
                {children}
                <label
                    htmlFor={htmlFor}
                    className={`absolute text-sm text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 ${peerFocusColor} peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 ${labelClassName} dark:text-white`}
                >
                    {label}
                </label>
            </div>
            {errorMessage && <p className="mt-2 text-sm text-red-600">
                {errorMessage}
            </p>}
        </div>
    );
};

export default InputFrame;
